<template>
  <div class="instagram-post-table">
    <el-table :data="posts" stripe @header-click="headerClick" empty-text="データがありません。" style="width: 100%">
      <el-table-column label="応募日時" sort-by="publishDatetime" :render-header="renderHeader" min-width="15%">
        <template slot-scope="scope">{{ formatDatetime(scope.row.publishDatetime) }}</template>
      </el-table-column>
      <el-table-column label="応募グループ" min-width="15%">
        <template slot-scope="scope">{{ scope.row.prizeName }}</template>
      </el-table-column>
      <el-table-column label="アカウント" min-width="15%">
        <template slot-scope="scope">
          <ApplicantName :applicant="scope.row" snsType="instagram"></ApplicantName>
        </template>
      </el-table-column>
      <el-table-column label="投稿内容" min-width="35%">
        <template slot-scope="scope">
          <div layout layout-align="space-between">
            <div class="message-body">{{ scope.row.message }}</div>
            <div class="post-image" v-if="scope.row.mediaUrl">
              <el-tooltip popper-class="image-zoom-tootip" placement="right">
                <div slot="content"><img :src="scope.row.mediaUrl" /></div>
                <img :src="scope.row.mediaUrl" />
              </el-tooltip>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column min-width="20%">
        <template slot-scope="scope">
          <div layout layout-align="end">
            <a :href="scope.row.permalink" target="_new" @click="clickInstagramConfirmation">
              <el-tooltip :enterable="false" placement="top" content="Instagramで確認">
                <el-button class="is-primary-button el-button--icon" type="default"
                  ><i class="mdi mdi-open-in-new"></i
                ></el-button> </el-tooltip></a
            ><a class="ml-x1" @click="changeIsWidget(scope.row)">
              <el-tooltip :enterable="false" placement="top" :content="widgetTooltipContent(scope.row)">
                <div>
                  <el-button
                    class="is-primary-button el-button--icon"
                    :type="scope.row.isWidget === 0 ? 'default' : 'primary'"
                    :disabled="scope.row.isNg === 1 && scope.row.isWidget === 0 ? true : false"
                    ><i class="mdi mdi-view-module"></i
                  ></el-button>
                </div> </el-tooltip></a
            ><a class="ml-x1" @click="changeIsCandidate(scope.row)">
              <el-tooltip :enterable="false" placement="top" :content="candidateTooltipContent(scope.row)">
                <div>
                  <el-button
                    class="is-primary-button el-button--icon"
                    :type="scope.row.isCandidate === 0 ? 'default' : 'primary'"
                    :disabled="scope.row.isNg === 1 && scope.row.isCandidate === 0 ? true : false"
                    ><i class="mdi mdi-star"></i
                  ></el-button>
                </div> </el-tooltip></a
            ><a class="ml-x1" @click="changeIsWinner(scope.row)">
              <el-tooltip placement="top" :content="winnerTooltipContent(scope.row)">
                <div>
                  <el-button
                    class="is-primary-button el-button--icon"
                    :type="scope.row.isWinner === 0 ? 'default' : 'primary'"
                    :disabled="scope.row.isNg === 1 && scope.row.isWinner === 0 ? true : false"
                    ><i class="mdi mdi-trophy"></i
                  ></el-button>
                </div> </el-tooltip
            ></a>
            <!-- NG追加/解除ボタン -->
            <a class="ml-x1" @click="changeNg(scope.row)">
              <el-tooltip :enterable="false" placement="top" :content="ngTooltipContent(scope.row)">
                <div>
                  <el-button
                    class="is-primary-button el-button--icon"
                    :type="scope.row.isNg === 1 ? 'primary' : 'default'"
                    ><i class="mdi mdi-cancel"></i
                  ></el-button>
                </div>
              </el-tooltip>
            </a>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="mt-x2" layout layout-align="space-between-center">
      <Pagination
        flex="1"
        type="応募履歴（IG）"
        :total="options.total"
        :pagingNo="options.pagingNo"
        :limitCount="options.limitCount"
        @paging="onPaging"
      ></Pagination>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { defineComponent } from 'vue'

import ApplicantName from '@/client/components/_atoms/applicant_name'
import Pagination from '@/client/components/_atoms/pagination'
import Util from '@/client/core/util'
import { formatDatetime } from '@/client/filters/filters'
import { TrackingService } from '@/client/services'
import { TInstagramPost } from '@/typings/api/instagram_posts.type'

export default defineComponent({
  components: { ApplicantName, Pagination },
  props: {
    posts: Array,
    options: Object
  },
  methods: {
    formatDatetime,

    /**
     * ウィジェットコンテンツを取得
     */
    widgetTooltipContent(post: TInstagramPost) {
      if (post.isNg && !post.isWidget) {
        return 'NGアカウント'
      }

      return post.isWidget ? 'ウィジェットから削除' : 'ウィジェットに追加'
    },

    /**
     * 候補者コンテンツを取得
     */
    candidateTooltipContent(post: TInstagramPost) {
      if (post.isNg && !post.isCandidate) {
        return 'NGアカウント'
      }

      return post.isCandidate ? '候補者を解除' : '候補者に追加'
    },

    /**
     * 当選者コンテンツを取得
     */
    winnerTooltipContent(post: TInstagramPost) {
      if (post.isNg && !post.isWinner) {
        return 'NGアカウント'
      }

      return post.isWinner ? '当選者を解除' : '当選者に追加'
    },

    /**
     * ウィジェットフラグを変更
     */
    changeIsWidget(post: TInstagramPost) {
      TrackingService.sendEvent('click:応募履歴（IG）|ウィジェットに追加')

      if (post.isNg && !post.isWidget) {
        return
      }

      this.$emit('change_is_widget', {
        postId: post.id,
        isWidget: post.isWidget
      })
    },

    /**
     * 候補者フラグを変更
     */
    changeIsCandidate(post: TInstagramPost) {
      TrackingService.sendEvent('click:応募履歴（IG）|候補者に追加')

      if (post.isNg && !post.isCandidate) {
        return
      }

      this.$emit('change_is_candidate', {
        applicantId: post.applicantId,
        isCandidate: post.isCandidate
      })
    },

    /**
     * 当選者フラグを変更
     */
    changeIsWinner(post: TInstagramPost) {
      TrackingService.sendEvent('click:応募履歴（IG）|当選者に追加')

      if (post.isNg && !post.isWinner) {
        return
      }

      this.$emit('change_is_winner', {
        prizeId: post.prizeId,
        applicantId: post.applicantId,
        isWinner: post.isWinner
      })
    },

    /**
     * ヘッダーをクリックするとソートする
     * @param {*} column
     * @returns {void}
     */
    headerClick(column: any): void {
      TrackingService.sendEvent('sort:応募履歴（IG）|応募日時')

      if (!column.sortBy) {
        return
      }

      if (column.sortBy.indexOf('-') === 0 && this.options.sortBy === column.sortBy) {
        this.$emit('sorting', column.sortBy.substring(1))
        return
      }

      if (column.sortBy.indexOf('-') !== 0 && this.options.sortBy === column.sortBy) {
        this.$emit('sorting', `-${column.sortBy}`)
        return
      }

      this.$emit('sorting', column.sortBy)
    },

    /**
     * ページング変更イベント
     * @param {any} payload
     * @returns {void}
     */
    onPaging(payload: any): void {
      this.$emit('paging', payload)
    },

    /**
     * ヘッダー描画
     * @param {*} createElement
     * @param {*} { column }
     */
    renderHeader(createElement: any, { column }: any): any {
      return Util.renderHeader(createElement, column.label, Util.getSortClass(this.options.sortBy, column.sortBy))
    },

    clickInstagramConfirmation() {
      TrackingService.sendEvent('click:応募履歴（IG）|Instagramで確認')
    },

    /**
     * NGアカウントツールチップを取得
     */
    ngTooltipContent(post: TInstagramPost) {
      return post.isNg === 1 ? 'NGアカウントを解除' : 'NGアカウントに追加'
    },

    /**
     * NGアカウントフラグを変更
     */
    changeNg(post: TInstagramPost) {
      TrackingService.sendEvent('click:応募履歴（Instagram）|NGアカウントに追加')
      this.$emit('change_ng', {
        screenName: post.screenName,
        isNg: post.isNg === 0,
        ngApplicantId: post.ngApplicantId ?? null
      })
    }
  }
})
</script>
<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.instagram-post-table {
  .message-body {
    width: 100%;
    max-height: $spacing-unit * 6;
    overflow-y: auto;
    white-space: pre-wrap;
  }

  .post-image {
    margin-left: $spacing-unit;

    img {
      max-width: $spacing-unit * 10;
      max-height: $spacing-unit * 7;
    }
  }

  .is-primary-button:focus {
    color: $text-color;
    background: #fff;
    border: 1px solid $border-color;
  }

  .is-primary-button.el-button--primary:focus {
    color: #fff;
    background-color: $primary-color;
    border-color: $primary-color;
  }
}
</style>
